/* 🤖 this file was generated by svg-to-ts */
export const matIconEditNote: {
  name: 'edit-note';
  data: string;
} = {
  name: 'edit-note',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 10h11v2H3v-2zm0-2h11V6H3v2zm0 8h7v-2H3v2zm15.01-3.13.71-.71a.996.996 0 0 1 1.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71-2.12-2.12zm-.71.71-5.3 5.3V21h2.12l5.3-5.3-2.12-2.12z"/></svg>`
};
